import { shareGoal2 } from "@assets";
import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, BodySmall, H2 } from "@components/Typography";
import { Routes } from "@ctypes";
import { useGoals, useModal, useSentShareGoalInvites } from "@hooks";
import { i18n, Translations } from "@i18n";
import { useNavigate } from "react-router-dom";
import { styles } from "./styles";
import { ShareGoalModalProps } from "./types";

const ITEMS = [
  i18n.t(Translations.ShareGoalModalItem1),
  i18n.t(Translations.ShareGoalModalItem2),
  i18n.t(Translations.ShareGoalModalItem3),
  i18n.t(Translations.ShareGoalModalItem4),
  i18n.t(Translations.ShareGoalModalItem5),
];

export const ShareGoalModal = ({ goalId }: ShareGoalModalProps) => {
  const navigate = useNavigate();
  const { dismiss } = useModal();

  const { data: invites } = useSentShareGoalInvites({ goalId });
  const { goals } = useGoals();

  const goal = goals.find((g) => g.id === goalId);

  const isSharedGoal = Boolean(invites?.length || goal?.partners?.length);

  const handleSubmit = () => {
    dismiss();

    if (isSharedGoal) {
      navigate(Routes.ShareGoal, { state: { goalId } });
    } else {
      navigate(Routes.ShareGoalContact, { state: { goalId } });
    }
  };

  const props: OverlayProps = {
    cta: {
      primary: {
        title: i18n.t(Translations.ShareGoalModalPrimaryCTA),
        onClick: handleSubmit,
      },
      secondary: {
        title: i18n.t(Translations.ShareGoalModalSecondaryCTA),
        onClick: dismiss,
      },
    },
  };

  return (
    <Overlay {...props}>
      <Spacing size={SpacingSizes.M} />

      <H2 style={styles.center}>{i18n.t(Translations.ShareGoalModalTitle)}</H2>
      <Spacing size={SpacingSizes.M} />

      <Body style={styles.center}>{i18n.t(Translations.ShareGoalCardSubtitle)}</Body>
      <Spacing size={SpacingSizes.M} />

      <div style={styles.image}>
        <img src={shareGoal2} alt="Share Goal" width={174} height={86} />
      </div>

      <Spacing size={SpacingSizes.M} />

      <Body style={styles.heading}>{i18n.t(Translations.ShareGoalModalHowItWorks)}</Body>
      <Spacing size={SpacingSizes.XXXS} />

      {ITEMS.map((item, index) => (
        <div key={`item-${index}`} style={styles.item}>
          <span>&bull;</span>
          <BodySmall>{item}</BodySmall>
        </div>
      ))}
      <Spacing size={SpacingSizes.M} />
    </Overlay>
  );
};
